<template>
<div v-role="'func'">
  <div v-if="this.$store.state.actividades.filter( a=>a.descricao === 'Matricula' && a.status_2 === 0).length">

  <v-card
    class="mx-auto"
    outlined
  >
  <v-overlay :value="overlay">
    <v-progress-circular
      indeterminate
      size="64"
    ></v-progress-circular>
 </v-overlay>
  <div class="text-center">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">Bloqueada</v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  </div>

  </v-card>

  </div>
<div v-if="this.$store.state.actividades.filter( a=>a.descricao === 'Matricula' && a.status_2 === 1).length">
  <br>
  <v-card
    class="mx-auto"
    max-width="1000"
  >
   <v-overlay :value="overlay">
    <v-progress-circular
      indeterminate
      size="64"
    ></v-progress-circular>
 </v-overlay>
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
    <v-row>
      <v-col md="4">
          <v-btn small to="/estudante/menu" class="mx-2" fab dark color="info">
            <v-icon small dark>arrow_back</v-icon>
          </v-btn>
      </v-col>
      <v-col md="5">
         <span v-if="showInformacao" style="color:red;font-size:16px;">
           
        </span>
      </v-col>
      <v-col md="3">
         <v-select
          :items="Listaranoslectivo"
          v-model="anolectivoSelected"
          item-value="descricao"
          item-text="novadescricao"
          label="Selecione o Ano lectivo"
          @change="filtrarAnoLectivo()"
          return-object
        ></v-select>
      </v-col>
    </v-row>
    <v-card-text>
       <v-container fluid>
   <v-alert
  v-if="hasMessage"
  :type="messageType"
  :color="messageColor"
  class="mb-4 px-4 py-3 elevation-1 rounded-lg custom-alert"
  border="left"
  dismissible
  @input="clearMessage"
>
  <template v-slot:prepend>
    <v-icon class="mr-2" size="20">
      {{ iconForType }}
    </v-icon>
  </template>

  <span class="text-body-2 font-weight-medium">{{ textMessage }}</span>
</v-alert>


        <v-row>
           
          <v-col cols="12" sm="6" md="12" >
            <p v-if="showInformacao" class="display-1" style="color:red">Confirmação de Matricula em ano anterior  </p>
            <p v-if="showInformacao">Você está a confirmar para o anolectivo anterior que é  <b>{{this.anolectivoSelected.novadescricao}}</b> e não no actual <b>{{anolectivoActual}}</b></p>
            <p v-else class="display-1 text--primary">Confirmação de Matricula </p>
          </v-col>
          </v-row>
  </v-container>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div class="text--primary">

          <v-row v-if="constrolo_estudantes_instituicao.length">

               <v-col class="d-flex" cols="12" sm="6" md="5">

                <v-autocomplete
                  v-model="editedItem.objecto"
                  :items="estudantes"
                  :loading="isLoading_"
                  :search-input.sync="search"
                  color="primary"
                  item-text="nome"
                  item-value="nome"
                  label="Nome do estudante"
                  placeholder="Digite o nome do estudante"
                  prepend-icon="mdi-magnify"
                  return-object
                  @change="loadTurmaComb"
                  :disabled="!constrolo_estudantes_instituicao.length"
                ></v-autocomplete>

                </v-col>
                 <v-col class="d-flex" cols="12" sm="6" md="3">
                     <v-combobox
                      v-model="editedItem.Turma"
                     item-value="pkTurma"
                    item-text="turmadescricao"
                    required
                    :hint="detalhe"
                    persistent-hint
                    :items="turmasFiltered"
                    label="Selecione a turma"
                    :disabled="invalid || !constrolo_estudantes_instituicao.length || AtingiuLimite"
                  ></v-combobox>
                </v-col>

                 <v-col class="d-flex" cols="12" sm="6" md="2">
                  
                 <v-btn class="mt-5" small :disabled="editedItem.Turma === null || editedItem.objecto === null || invalid || !constrolo_estudantes_instituicao.length || AtingiuLimite"  color="primary"  @click="save"  >Confirmar</v-btn>

             </v-col>
               <v-col class="d-flex" cols="12" sm="6" md="2">
                     <v-progress-circular
                    v-if="progresso"
                    indeterminate
                    color="green"
                ></v-progress-circular>
               </v-col>
          </v-row>
     
     <v-card class="pa-4 mb-4" v-if="editedItem.objecto">
 <v-row class="mb-1" justify="space-between" align="center" v-if="editedItem.objecto.resultado !== 'Transita'">
  <span class="text-h6">Informações do estudante</span>

  <v-btn
    text
    small
    color="info"
    class="d-flex align-center"
    @click="verBoletim(editedItem.objecto)"
  >
    <span class="mr-1">Ver boletim de notas</span>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          small
        >
          mdi-file-document-outline
        </v-icon>
      </template>
      <span>Ver boletim de notas</span>
    </v-tooltip>
  </v-btn>
</v-row>


  <v-divider class="my-2"></v-divider>

  <v-card-text>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <p class="text-subtitle-2 font-weight-medium mb-1">Última classe feita</p>
        <p class="text-body-2">{{ classe }}</p>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <p class="text-subtitle-2 font-weight-medium mb-1">Curso</p>
        <p class="text-body-2">{{ editedItem.objecto.descricao }}</p>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <p class="text-subtitle-2 font-weight-medium mb-1">Último ano lectivo</p>
        <p class="text-body-2">{{ editedItem.objecto.ControloUltimoParaOproximoAno }}</p>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <p class="text-subtitle-2 font-weight-medium mb-1">Resultado obtido</p>
        <p
          class="text-body-2 font-weight-bold"
          :class="{
            'text-success': editedItem.objecto.resultado === 'Transita',
            'text-error': editedItem.objecto.resultado !== 'Transita'
          }"
        >
          {{ editedItem.objecto.resultado }}
        </p>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>


          <!--** -->
            <v-row v-if="!constrolo_estudantes_instituicao.length && !overlay">
               <v-col md="12">
                     <v-row>
                      <v-col md="12">
                        <span style="font-weight:bold;"> ATT : </span><span
                          style="font-weight:bold;font-size:14px;color:#006699;">Estatística
                          não configurada no sistema.</span>
                      </v-col>
                    </v-row>
               </v-col>
            </v-row>
            <v-row v-if="constrolo_estudantes_instituicao.length && editedItem.objecto !== null && !overlay">
               <v-col md="12">
                     <v-row>
                      <v-col md="12" v-if="!invalid">
                        <span style="font-weight:bold;font-size:14px;">Nº Estudantes permitidos na  :
                          {{(constrolo_estudantes_instituicaoFilter.length)? constrolo_estudantes_instituicaoFilter[0].quantidade : ''}}</span>
                      </v-col>
                      <v-col md="12" v-if="!invalid">
                        <span style="font-weight:bold;font-size:14px;">Nº Estudantes existentes:</span>
                        <v-chip> {{(cadastrados.length)?cadastrados[0].cadastrados : '' }}</v-chip>
                      </v-col>
                      <v-col md="12" v-if="AtingiuLimite && !invalid">
                        <span style="font-weight:bold;"> ATT: </span><span
                          style="font-weight:bold;font-size:14px;color:red;">De acordo com a estatística fornecida ao ITSL você atingiu o limite de estudantes para a
                          {{getClasse(classeConfirmacao)}}
                           </span>
                      </v-col>
                    </v-row>
               </v-col>
            </v-row>
           
      </div>
    </v-form>
    </v-card-text>

  </v-card>
</div>
</div>
</template>
<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
const ls = require('local-storage')

export default {
  data: () => ({
    Listaranoslectivo: [],
    invalid: false,
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    anolectivoSelected: ls.get('anolectivo'),
    estudantes: [],
    anolectivoActual: ls.get('novadescricao'),
    turmasAll: [],
    constrolo_estudantes_instituicao: [],
    constrolo_estudantes_instituicaoFilter:[],
    listaDeClassesPorLancarNotas: [],
    turmasFiltered: [],
    cadastrados: [],
    showInformacao:false,
    overlay: false,
     valid: true,
    jaMatriculado: '',
    classe: '',
    detalhe: '',
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    exibe: false,
    classeConfirmacao:null,
    acesso: [],
    descriptionLimit: 60,
    entries: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      objecto: null,
      Turma: null
    },
    ruleRequired: [value => value || 'campo obrigatorio']
  }),

  computed: {

    hasMessage() {
    return this.$store.state.hasMessage
  },
  textMessage() {
    return this.$store.state.textMessage
  },
  messageType() {
    // info | success | warning | error
    return this.$store.state.classMessage || 'info'
  },
  messageColor() {
    const map = {
      success: '#4CAF50',
      error: '#FF5252',
      info: '#2196F3',
      warning: '#FFC107'
    }
    return map[this.messageType] || '#2196F3'
  },
  iconForType() {
    const icons = {
      success: 'mdi-check-circle-outline',
      error: 'mdi-alert-circle-outline',
      warning: 'mdi-alert-outline',
      info: 'mdi-information-outline'
    }
    return icons[this.messageType] || 'mdi-information-outline'
  },

     AtingiuLimite() {
      let result = ((this.constrolo_estudantes_instituicaoFilter.length) ? parseInt(this.constrolo_estudantes_instituicaoFilter[0].quantidade) : 0) - ((this.cadastrados.length) ? parseInt(this.cadastrados[0].cadastrados) : 0)
      return (result <= 0)
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    }
  },

  watch: {

    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 3) {
      // Items have already been requested
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
        }
        return this.Initialize(val)
      }
    }

  },
  created () {
    // this.VerificaAcesso()
    this.CarregActividades()
    // this.Initialize()
     this.initializeturmasAll(ls.get('anolectivo'))
     this.turmaFindWithEstudanteCount()
    this.initializeAnosLectivo()
    this.InitializeEstatisticaEstudante()
  },

  methods: {

    async Initialize (searchDB) {
      this.isLoading = true
      this.isLoading_ = true
      if (!this.estudantes.length) {
        if (searchDB) {
          var payload = '{ "find" : "' + searchDB + '" }'
        } else {
          payload = '{ "find":"all" }'
        }
        try {
          // this.isLoading = true
          this.estudantes = await axios
            .get('/EstudantesConfirmacao/' + payload)
            .then(res => res.data)
          this.isLoading = false
          this.isLoading_ = false
        } catch (error) {
          this.isLoading = false
          this.isLoading_ = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
      this.isLoading = false
      this.isLoading_ = false
    },

    async filtrarAnoLectivo (){
      this.initializeturmasAll(this.anolectivoSelected.descricao)
      this.InitializeEstatisticaEstudante()
      if(parseInt(this.anolectivoSelected.descricao) < parseInt(ls.get('anolectivo'))){
          this.showInformacao = true
      }else{
          this.showInformacao = false
      }
    },

    clearMessage() {
    this.$store.commit('clearMessage') // define no store
  },


    async verBoletim(item){      

      if (item) {
          const objecto = {
            idMAtricula: item.idMatricula,
            anoLectivo: item.anoLectivo,
            pkInscricao_na_turma: item.pkInscricao_na_turma,
            nome: item.nomeUnico
          }

          this.$store.commit('setObjAluno', objecto)
          this.$router.push('/turma/Novo-Boletim')
        }
       
      },
 

    async initializeAnosLectivo () {
        try {
          this.Listaranoslectivo = await axios
            .get('/listarAnoLectivoAll2')
            .then(res => res.data)
           this.isLoading = false
           if(this.Listaranoslectivo.length)
              this.anolectivoSelected = this.Listaranoslectivo.filter(a=>a.descricao === ls.get('anolectivo'))[0]
           else
              this.anolectivoSelected = null
        } catch (error) {
          this.isLoading = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.isLoading = false
        }
    },

    ListarEstudantes (item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },

    async save () {
      if ((this.$refs.form.validate())) {
        this.progresso = true
        let params =
                {
                  idmatricula: this.editedItem.objecto.idMatricula,
                  idturma: this.editedItem.Turma.idTurma,
                  pkPessoa: this.editedItem.objecto.pkPessoa,
                  idanolectivo: this.editedItem.objecto.anolectivo,
                  pkTurma: this.editedItem.Turma.pkTurma,
                  idcurso: this.editedItem.Turma.idCurso,
                  bi: this.editedItem.objecto.pkPessoa,
                  idanoacademico: this.editedItem.Turma.idAno_Academico,
                  resultado: (this.editedItem.objecto.resultado === 'Transita') ? 1 : 0,
                  descricao_resultado: this.editedItem.objecto.resultado,
                  fromtransferencia: 0,
                  fromMudancaclasse: 0,
                  ultimoAnoFeito: this.editedItem.objecto.anolectivo,
                  anolectivo: this.anolectivoSelected.descricao
                }

        try {
          // this.isLoading = true
          let msg = await axios
            .post('/confirmacaoInsertOrUpdate', params)
            .then(res => res.data)
          if(!msg.length){
            this.Limpar('CONFIRMAÇÃO EFECTUADA COM SUCESSO')
            this.progresso = false
            this.text = 'CONFIRMAÇÃO EFECTUADA COM SUCESSO'
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          }else{
              this.progresso = false
              this.text = 'Ocorreu um erro ao tentar efectuar a operação'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }
          
        } catch (error) {
          this.progresso = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Limpar (msg) {
      if (msg === 'CONFIRMAÇÃO EFECTUADA COM SUCESSO') {
        const index = this.estudantes.indexOf(this.editedItem.objecto)
        this.estudantes.splice(index, 1)
        // eslint-disable-next-line no-unused-expressions
        this.editedItem.objecto = null
        this.editedItem.Turma = null
        this.classe = ''
        this.$refs.form.resetValidation()
        this.turmaFindWithEstudanteCount()
      }
    },

    async initializeturmasAll (anolectivo) {
      try {
        // this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAllAno/'+anolectivo)
          .then(res => res.data)
        this.turmase
       } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async turmaFindWithEstudanteCount () {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },


     async InitializeEstatisticaEstudante () {
      try {
        this.overlay = true
        this.constrolo_estudantes_instituicao = await axios.post('/Config_instituicao_estudantes', {anolectivo:(this.anolectivoSelected.descricao === null || this.anolectivoSelected.descricao === undefined)?this.anolectivoSelected:this.anolectivoSelected.descricao}).then((res)=>res.data)
        this.overlay = false
       } catch (error) {
          this.overlay = false
          Swal.fire('Informação','Ocorreu um erro ao tentar carregar a estatistica de cadastro','error')
      }

    },

    async verificaSeJaConfirmado(){
       try {
        this.overlay = true
        this.jaMatriculado = await axios
          .post('/Estudante-ja-Confirmado',{ idMatricula:this.editedItem.objecto.idMatricula,anolectivo:this.anolectivoSelected.descricao })  
          .then(res => res.data)
        this.overlay = false
       } catch (error) {
        // this.isLoading = false
        this.overlay = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

     getClasse(idclasse) {
      switch (idclasse) {
        case 1:
          return '10ª classe'
        case 2:
          return '11ª classe'
        case 3:
          return '12ª classe'
        case 4:
          return '13ª classe'
      }
    },

    async ObterClasse () {
      if (parseInt(this.editedItem.objecto.anoacademico) === 1) { this.classe = '10ª Classe' }
      if (parseInt(this.editedItem.objecto.anoacademico) === 2) { this.classe = '11ª Classe' }
      if (parseInt(this.editedItem.objecto.anoacademico) === 3) { this.classe = '12º Classe' }
      if (parseInt(this.editedItem.objecto.anoacademico) === 4) { this.classe = '13ª Classe' }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    async InitializeCadastrados(classe) {
      try {
        this.overlay = true
        this.cadastrados = await axios.post('/estudantes_cadastrados', { classe: classe, anolectivo: this.anolectivoSelected }).then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.$store.dispatch('textMessage', { 'msg': 'Ocorreu um erro ao tentar efectuar a operação.', 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.ObterClasse()
      if(parseInt(this.editedItem.objecto.anoLectivo) > (parseInt(this.anolectivoSelected.descricao))){
          this.invalid = true
          Swal.fire('Informação','Este estudante não pode ser confirmado no anolectivo anterior.','warning')
      }else{
          this.invalid = false
          this.verificaSeJaConfirmado().then(async ()=>{
          this.invalid = false
          this.turmasFiltered = []
          if(this.jaMatriculado <=0 ){
            this.editedItem.Turma = null
          if (this.editedItem.objecto.resultado === 'Transita') { 
             this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.objecto.idCurso && t.idAno_Academico === (parseInt(this.editedItem.objecto.anoacademico) + 1)) 
             this.InitializeCadastrados((parseInt(this.editedItem.objecto.anoacademico) + 1))
             this.constrolo_estudantes_instituicaoFilter = this.constrolo_estudantes_instituicao.filter(f=>parseInt(f.anoacademico) ===(parseInt(this.editedItem.objecto.anoacademico) + 1) )
             this.classeConfirmacao = (parseInt(this.editedItem.objecto.anoacademico) + 1)
          } else { 
             this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.objecto.idCurso && t.idAno_Academico === parseInt(this.editedItem.objecto.anoacademico)) 
             this.InitializeCadastrados((parseInt(this.editedItem.objecto.anoacademico)))
             this.constrolo_estudantes_instituicaoFilter = this.constrolo_estudantes_instituicao.filter(f=>parseInt(f.anoacademico) === (parseInt(this.editedItem.objecto.anoacademico)))
             this.classeConfirmacao = (parseInt(this.editedItem.objecto.anoacademico))
          }
          if (this.turmasFiltered.length) { this.detalhe = '' } else { this.detalhe = 'Não existem turmas cadastradas para este curso e classe!' }
          }else{
               this.invalid = true
               this.$store.dispatch('textMessage', {msg: 'Estudante já confirmado no anolectivo actual',classMessage: 'msgError',timeout: 8000})
          }
      })
      }
    }

  }
}
</script>
<style scoped>
.custom-alert {
  transition: all 0.3s ease;
  font-size: 14px;
  line-height: 1.5;
}
</style>